// Fetches a site favicon and returns it as a base64 data URL. The actual network
// fetch happens server-side in a per-user Puter worker (see
// favicon-worker-source.js / favicon-worker-client.js), so the browser only
// connects to *.puter.work — never directly to the site or DuckDuckGo. See
// CLAUDE.md and RECOVERY.md before broadening this.
//
// Never throws. Never logs. Returns null on any failure — including when Puter
// is unavailable (outside a Puter session) — so callers fall back to the avatar.

import { ensureFaviconWorker } from './favicon-worker-client.js';

const MAX_DATAURL_LEN = 100 * 1024; // base64 of a ~50KB icon ≈ 68KB; generous cap

export async function fetchFavicon(url) {
  if (typeof globalThis.puter?.workers?.exec !== 'function') return null;

  const host = extractHost(url);
  if (!host) return null;

  const base = await ensureFaviconWorker();
  if (!base) return null;

  let res;
  try {
    res = await globalThis.puter.workers.exec(`${base}/icon?host=${encodeURIComponent(host)}`);
  } catch {
    return null;
  }
  if (!res || !res.ok) return null;

  let data;
  try {
    data = await res.json();
  } catch {
    return null;
  }

  const dataUrl = data?.dataUrl;
  if (typeof dataUrl !== 'string' || !dataUrl.startsWith('data:image/')) return null;
  if (dataUrl.length > MAX_DATAURL_LEN) return null;
  return dataUrl;
}

function extractHost(input) {
  if (typeof input !== 'string') return null;
  const trimmed = input.trim();
  if (trimmed.length === 0) return null;
  const withProto = /^[a-z][a-z0-9+.-]*:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  try {
    const u = new URL(withProto);
    if (!u.hostname) return null;
    return u.hostname.toLowerCase();
  } catch {
    return null;
  }
}
